import React, { useState } from "react";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";
import { ReorderModal } from "../../../../../../boxes/ReorderModal/ReorderModal";
import { Select } from "../../../../../../shared/Select/Select";
import { useClinics } from "./hooks/useClinics";
import { useUsers } from "./hooks/useUsers";
import { useSelectedClinic } from "./hooks/useSelectedClinic";
import { useSaveOrder } from "./hooks/useSaveOrder";

export function ObOrder() {
  const { tCommon } = useAppTranslation.Common();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { clinicsList, isClinicsLoading } = useClinics();
  const { selectedClinic, selectClinic } = useSelectedClinic(clinicsList);
  const { users, isUsersLoading } = useUsers(selectedClinic?.value);
  const { save, isSaving } = useSaveOrder();

  const submit = (orderedUsers) => {
    save({
      selectedClinic,
      orderedUsers,
    });
  };

  return (
    <>
      <button
        className="easy-link no-padding"
        onClick={() => setIsModalOpen(true)}
      >
        {tCommon("label.obOrder")}
      </button>
      {isModalOpen && (
        <ReorderModal
          isLoading={isClinicsLoading || isUsersLoading}
          isSaving={isSaving}
          isOpen={isModalOpen}
          data={users}
          onClose={() => setIsModalOpen(false)}
          title={tCommon("label.obOrder")}
          onSave={submit}
          renderSubheader={({ isTouched }) => (
            <Select
              isDisabled={isSaving}
              options={clinicsList}
              value={selectedClinic}
              onChange={(next) => selectClinic({ next, isTouched })}
            />
          )}
        />
      )}
    </>
  );
}
